import { jsxs as a, jsx as l } from "react/jsx-runtime";
const r = (c) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#drupal-colored_svg__a)", children: /* @__PURE__ */ l("g", { clipPath: "url(#drupal-colored_svg__b)", children: /* @__PURE__ */ l(
        "path",
        {
          fill: "#009DDE",
          d: "M12.006.002C18.63.005 23.999 5.376 23.999 12v.005C23.997 18.63 18.623 24 11.997 23.998S0 18.62.003 11.996 5.38 0 12.006.002m-.062 3.086c-.33 1.247-1.44 2.354-2.603 3.518-1.74 1.744-3.718 3.718-3.718 6.682a6.33 6.33 0 0 0 6.314 6.322 6.33 6.33 0 0 0 6.329-6.322c0-2.964-1.972-4.937-3.718-6.682l-.156-.156c-1.105-1.107-2.134-2.17-2.448-3.362m.086 9.467a35 35 0 0 1 1.664 1.889q.054.065.097.14a2.187 2.187 0 1 1-3.402-.236c.466-.55 1.028-1.091 1.641-1.793M9.141 9.654l.305.288 1.416 1.448a.16.16 0 0 1 0 .213l-1.48 1.636-.518.63a3.8 3.8 0 0 0-.497.783.15.15 0 0 1-.108.092h-.053c-.143-.012-.308-.277-.308-.277l-.026-.04a2 2 0 0 1-.094-.165l-.028-.06a3.75 3.75 0 0 1-.048-2.03l.02-.069c.157-.555.405-1.08.734-1.554q.317-.467.685-.895m2.812-2.928c.378.429.803.858 1.204 1.259l.008.028c.839.78 1.596 1.643 2.262 2.575.566.795.875 1.743.887 2.719 0 .422-.064.84-.189 1.243l-.006.017a.26.26 0 0 1-.194.156h-.04a.36.36 0 0 1-.205-.165l-.067-.1a11 11 0 0 0-1.216-1.504l-.578-.61-1.926-2.006c-.325-.313-.906-.874-1.151-1.179a.3.3 0 0 0-.028-.047 1 1 0 0 1-.152-.301v-.06a1 1 0 0 1 .075-.578q.082-.174.217-.308c.373-.373.746-.738 1.1-1.14"
        }
      ) }) }),
      /* @__PURE__ */ a("defs", { children: [
        /* @__PURE__ */ l("clipPath", { id: "drupal-colored_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) }),
        /* @__PURE__ */ l("clipPath", { id: "drupal-colored_svg__b", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
      ] })
    ]
  }
);
export {
  r as default
};
